import { Card, styled } from "@mui/material";

export const StyledCard = styled(Card)(({ theme: { palette } }) => ({
  height: "100%",
  background: palette.main[50],

  "&.highlighted": {
    border: `4px solid ${palette.common.white}`,
    boxShadow: `0 0 0 4px ${palette.primary.main}`,
  },
}));
